import fetcher from './fetchers'

export const doCheckIsExists = (params) => {
  return fetcher.post('/v1/ugc/check/is_exists', params)
}

export const doCommit = (params) => {
  return fetcher.post('/v1/ugc/author/contract/commit', params)
}

// 【分块上传】初始化
export const uploadMultipartInit = (params) => {
  return fetcher.post('/v1/ugc/author/multipart/init', params)
}

// 【分块上传】上传
export const uploadMultipartUpload = (params, config) => {
  return fetcher.post('/v1/ugc/author/multipart/upload', params, config)
}

// 【分块上传】完成
export const uploadMultipartComplete = (params, config) => {
  return fetcher.post('/v1/ugc/author/multipart/complete', params, config)
}

// 发送手机验证码
export const sendSmscode = (params, config) => {
  params.scene = 'yuanqi_sms'
  return fetcher.post('/v1/smscode/send', params, config)
}

export const sendUploadSmscode = (params, config) => {
  params.scene = 'yuanqi_sms_upload_wallpaper'
  return fetcher.post('/v1/smscode/send', params, config)
}

export const doRealnameCommit = (params, config) => {
  return fetcher.post('/v1/ugc/encrypted/realname/auth', params, config)
}
